export interface IExternalAppConfig {
  version?: string | null;
  customTitleBar?: boolean;
  customTitleBarHeight?: number | string;
}

class ExternalAppConfig {
  private _version?: string | null;
  private _customTitleBar?: boolean;
  private _customTitleBarHeight?: number | string;

  get version(): string | null | undefined {
    return this._version || window.externalAppConfig?.version;
  }

  get customTitleBar(): boolean | undefined {
    return this._customTitleBar || window.externalAppConfig?.customTitleBar;
  }

  get customTitleBarHeight(): number | string | undefined {
    return this._customTitleBarHeight || window.externalAppConfig?.customTitleBarHeight;
  }

  update(info: IExternalAppConfig): void {
    if (info.version !== undefined) {
      this._version = info.version as string | null;
    }
    if (info.customTitleBar !== undefined) {
      this._customTitleBar = info.customTitleBar as boolean;
    }
    if (info.customTitleBarHeight !== undefined) {
      this._customTitleBarHeight = info.customTitleBarHeight as number | string;
    }
  }
}

const externalAppConfig = new ExternalAppConfig();

export default externalAppConfig;